<header class="navbar navbar-expand-lg navbar-dark fixed-top" style="background: #004c97;">
    <div class="container-fluid">
        <button type="button" id="emiplus-menu" class="btn btn-light btn-sm d-none" (click)="toggleSideBar()">
            <i class="fas fa-bars" style="color: #004c97;"></i>
        </button>
        <div class="d-flex justify-content-between flex-row-reverse align-items-center flex-wrap">
            <img alt="" src="../assets/images/Logo_GEPP.3b4d362a.svg" class="divLogoHeader">
        </div>
        <div class="d-flex justify-content-between justify-content-end divUserHeader">

            <div class="d-block mt-2 mr-3">
                <div class="lblHeaderCompany">{{ companyName }} </div>
                <div class="lblHeaderUser text-right">{{ name }} </div>
            </div>

            <div class="navbar-brand" href="#">

                <i class="fa-solid fa-circle-user fa-2x"></i>

            </div>

        </div>
    </div>
</header>